import { type CountryCode, type ProjectCode } from '@constants'
import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Link } from '@pets-ui/Link/Link'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { getCustomerServiceUrl } from '../utils/get-customer-service-url'

export const DIALOG_MANUAL_REFUND_REQUIRED = 'DIALOG_MANUAL_REFUND_REQUIRED'

export interface DialogManualRefundRequiredExtraProps {
  isMerchant: boolean
  projectCode?: ProjectCode
  countryCode?: CountryCode
}

export function DialogManualRefundRequired() {
  const { open, closeDialog, isMerchant, projectCode, countryCode } = useDialog<DialogManualRefundRequiredExtraProps>(DIALOG_MANUAL_REFUND_REQUIRED)

  const title = isMerchant
    ? '此訂單需人工退款，請聯繫業務'
    : '此訂單需人工退款，請聯繫客服'

  const customerServiceUrl = getCustomerServiceUrl(projectCode, countryCode)

  return (
    <Dialog onClose={closeDialog} open={open} maxWidth={320} fullWidth>
      <DialogHeader align="center" title={title} />
      <DialogContent>
        {isMerchant
          ? (
            <Text color={colors.grey800}>
              此類付款方式（如 ATM、PayMe）需由業務執行退費作業，請聯繫業務處理。
            </Text>
          )
          : (
            <Text color={colors.grey800}>
              此類付款方式（如 ATM、超商、PayMe）需由客服執行退費作業，請
              {customerServiceUrl
                ? (
                  <Link
                    href={customerServiceUrl}
                    target="_blank"
                    underline
                  >
                    聯繫客服
                  </Link>
                )
                : '聯繫客服'}
              處理。
            </Text>
          )}
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} variant="filled" color="primary" fullWidth>確認</Button>
      </DialogActions>
    </Dialog>
  )
}
